import { createRouter, createWebHistory } from '@ionic/vue-router';
import { getLocalData, setLocalData } from '@/utils/localdata'

const isAuthenticated = async() => {
  let authenticated = await getLocalData('authToken')
  return authenticated == null ? false : true;
};
const introViewed = async() => {
  return await getLocalData('intro');
};
const hasLang = async() => {
  return await getLocalData('lang');
};

const pages = require.context('@/pages', true, /\.vue$/);

// Auto-router: Carga todos los componentes dentro de la carpeta "pages"
const autoRoutes = pages.keys().map((file) => {
  const name = file.replace('./', '').replace('.vue', '').toLowerCase();
  const path = name === 'index' ? '/' : `/${name}`;
  const component = pages(file).default;

  // ❌ Esto no evita duplicados porque más abajo los vuelves a pushear
  if (path.startsWith('/app')) return null;

  return { path, component };
}).filter(Boolean);

// pages.keys().forEach((file) => {
//   const name = file.replace('./', '').replace('.vue', '').toLowerCase(); // Nombre de la ruta
//   const path = name === 'index' ? '/' : `/${name}`; // '/' para 'index.vue'
//   const component = pages(file).default; // Carga el componente dinámicamente

//   autoRoutes.push({
//     path,
//     component,
//   });
// });

// Rutas adicionales que no se generan automáticamente
const additionalRoutes = [
  {
    path: '/app/secrets/new',
    component: () => import('@/pages/app/secrets/new.vue'),
    meta: { noAnimate: true },
  },
  {
    path: '/app/secrets/edit/:id',
    component: () => import('@/pages/app/secrets/new.vue'),
    meta: { noAnimate: true, isEdit: true },
  },
  {
    path: '/app/matchs/view',
    component: () => import('@/pages/app/matchs/view.vue'),
    meta: { noAnimate: true },
  },
];
const routesTabs = [
  {
    path: '/app',
    component: () => import('@/pages/index.vue'),
    children: [
      {
        path: 'fans',
        component: () => import('@/views/Fans.vue'),
        meta: { noAnimate: true },
      },
      {
        path: 'secrets',
        component: () => import('@/views/Secrets.vue'),
        meta: { noAnimate: true },
      },
      {
        path: 'matchs',
        component: () => import('@/views/Matchs.vue'),
        meta: { noAnimate: true },
      },
      {
        path: 'account',
        component: () => import('@/views/Account.vue'),
        meta: { noAnimate: true },
      },
      {
        path: 'help',
        component: () => import('@/views/Help.vue'),
        meta: { noAnimate: true },
      },
    ],
  },
  {
    path: '/',
    redirect: '/app/fans', // Redirige a la tab inicial
  },
];
// Combinar rutas dinámicas con rutas adicionales
// additionalRoutes va primero para que /app/secrets/new tenga prioridad sobre /app/*
const routes = [...additionalRoutes, ...routesTabs, ...autoRoutes];

// Crear el router
const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL || '/'),
  routes,
});

// --- Google Tag Manager / Analytics tracking ---
router.afterEach((to) => {
  // Evita errores si no existe dataLayer todavía
  window.dataLayer = window.dataLayer || [];

  // Empuja evento de vista de pantalla
  const lastSegment = to.fullPath.substring(to.fullPath.lastIndexOf('/') + 1);
  window.dataLayer.push({
    event: 'page_view',
    page_path: to.fullPath,
    page_name: lastSegment,
    page_title: lastSegment
  });
});

router.beforeEach(async (to, from, next) => {
  const isAuthRoute = to.path.startsWith('/auth/');
  const lang = await getLocalData('lang');
  const intro = await getLocalData('intro');
  const token = await getLocalData('authToken');

  // Rutas que siempre deben pasar sin redirección
  if (to.path === '/lang' || to.path === '/auth/register' || to.path.startsWith('/app/help')) {
    next();
    return;
  }

  if (!lang) {
    next('/lang');
    return;
  }
  if (!token || token === 'null' || token === 'undefined') {
    // NO está logueado
    if (isAuthRoute) {
      // puede seguir navegando dentro de /auth/*
      if (to.path === '/auth/intro' && intro) {
        next('/auth/login');
      } else {
        next();
      }
    } else {
      // No puede acceder a rutas protegidas sin login
      if (!intro) {
        next('/auth/intro');
      } else {
        next('/auth/login');
      }
    }
  } else {
    // SÍ está logueado
    if (isAuthRoute) {
      next('/'); // Evita volver al login
    } else {
      next();
    }
  }
});

export default router;